import { TranslationMap } from '@trimble-gcs/i18n-types';

export function recycleBinTableTranslations() {
  return {
    columns: {
      name: {
        text: $localize`:@@recycleBinTable.columns.name:Name`,
        desc: "The 'Name' column header in a table.",
      },
      status: {
        text: $localize`:@@recycleBinTable.columns.status:Status`,
        desc: "The 'Status' column header in a table.",
      },
      deletedBy: {
        text: $localize`:@@recycleBinTable.columns.deletedBy:Recycled By`,
        desc: "The 'Recycled By' column header in a table.",
      },
      deletedDate: {
        text: $localize`:@@recycleBinTable.columns.deletedDate:Recycled Date`,
        desc: "The 'Recycled Date' column header in a table.",
      },
      uploadedBy: {
        text: $localize`:@@recycleBinTable.columns.uploadedBy:Uploaded By`,
        desc: "The 'Uploaded By' column header in a table.",
      },
      uploadedDate: {
        text: $localize`:@@recycleBinTable.columns.uploadedDate:Upload Date`,
        desc: "The 'Upload Date' column header in a table.",
      },
      captureDate: {
        text: $localize`:@@recycleBinTable.columns.captureDate:Capture Date`,
        desc: "The 'Capture Date' column header in a table.",
      },
      pointCount: {
        text: $localize`:@@recycleBinTable.columns.pointCount:Points`,
        desc: "The 'Points' column header in a table. Represents a count of points.",
      },
      fileSize: {
        text: $localize`:@@recycleBinTable.columns.fileSize:Size`,
        desc: "The 'Size' column header in a table. Represents a file size.",
      },
      tags: {
        text: $localize`:@@recycleBinTable.columns.tags:Tags`,
        desc: "The 'Tags' column header in a table.",
      },
    },
    pointcloudStatus: {
      uploading: {
        text: $localize`:@@recycleBinTable.pointcloudStatus.uploading:Uploading`,
        desc: 'The icon tooltip for pointclouds that are busy uploading.',
      },
      processing: {
        text: $localize`:@@recycleBinTable.pointcloudStatus.processing:Processing`,
        desc: 'The icon tooltip for pointclouds that are busy processing.',
      },
      ready: {
        text: $localize`:@@recycleBinTable.pointcloudStatus.ready:Ready`,
        desc: 'The icon tooltip for pointclouds that have been processed and are ready to view.',
      },

      failed: {
        text: $localize`:@@recycleBinTable.pointcloudStatus.failed:Failed`,
        desc: 'The icon tooltip for pointclouds that failed processing.',
      },
    },
    daysSinceDeleted: {
      '=0': {
        text: $localize`:@@recycleBinTable.daysSinceDeleted.zero:Today`,
        desc: "The text shown when the pointcloud was recycled on today's date.",
      },
      '=1': {
        text: $localize`:@@recycleBinTable.daysSinceDeleted.one:Yesterday`,
        desc: "The text shown when the pointcloud was recycled on yesterday's date.",
      },
      other: {
        text: $localize`:@@recycleBinTable.daysSinceDeleted.other:{count} days ago`,
        desc: 'The text shown to indicate the number of days since the pointcloud was recycled.',
      },
    },
  } satisfies TranslationMap;
}
